module.exports = "/templates/selfregistration.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/selfregistration.html
// module id = 459
// module chunks = 0